export const SYSTEM_PAYROLL_COLUMNS = {
  WEEKLY_TIME: 'weeklyTime',
} as const;

export const ABSENCE_COLUMNS = {
  ABSENCE_JUSTIFIED: 'ABSENCE_JUSTIFIED',
  ABSENCE_UNJUSTIFIED: 'ABSENCE_UNJUSTIFIED',
} as const;

export const OVERTIME_COLUMNS = {
  OVERTIME_SIMPLE: 'OVERTIME_SIMPLE',
  OVERTIME_NIGHT: 'OVERTIME_NIGHT',
  OVERTIME_HOLIDAYS: 'OVERTIME_HOLIDAYS',
} as const;

export const LEAVE_COLUMNS = {
  LEAVE_SIMPLE: 'LEAVE_SIMPLE',
  LEAVE_EXCEPTIONAL: 'LEAVE_EXCEPTIONAL',
  LEAVE_SICK: 'LEAVE_SICK',
} as const;

export const DEDUCTION_COLUMNS = {
  DEDUCTION: 'DEDUCTION',
} as const;

export const PAYROLL_VARIABLE_COLUMNS = {
  // System columns
  ...SYSTEM_PAYROLL_COLUMNS,

  // Dynamic columns
  ...ABSENCE_COLUMNS,
  ...OVERTIME_COLUMNS,
  ...LEAVE_COLUMNS,
  ...DEDUCTION_COLUMNS,
} as const;
